<template>
  <div>
    <breadcrumbs :home="vesselName + ': Initial inventory'"/>

      <v-card flat>
        <v-form v-model="valid" ref="form" :disabled="!edit">
          <v-container class="pt-6 px-6 purtrak-scrollable" fluid>

            <v-row dense>
              <v-col cols="6" sm="4" lg="3">
                <date-picker v-model="transaction.date"/>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="6" sm="3" lg="2">
                <alcohol-input label="Volume"
                               :spirit="spirit"
                               v-model="transaction.volume"
                               :litres.sync="transaction.litres"
                               :kg.sync="transaction.kg"
                               :strength.sync="transaction.strength"
                               :disabled="!edit"/>
              </v-col>
              <v-col cols="6" sm="3" lg="2" v-if="transaction.alcoholType!=='Spirit' && transaction.alcoholType!=='NonExcise'">
                <decimal-number-input label="Strength" v-model="transaction.strength" :disabled="!edit" suffix="% alc./vol."/>
              </v-col>
              <v-col cols="6" sm="3" lg="2">
                <decimal-number-input label="Value" v-model="transaction.value" :disabled="!edit"/>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="6" sm="3" lg="2">
                <v-text-field outlined dense label="Lot" v-model="transaction.lot" :rules="[fieldRules.required,fieldRules.maxLength(20)]"/>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-text-field label="Comments" v-model="transaction.comments" outlined dense counter="255" :rules="[fieldRules.required,fieldRules.maxLength(255)]"/>
              </v-col>
            </v-row>
          </v-container>
        </v-form>

        <v-divider/>
        <v-card-actions class="px-6">
          <template v-if="company.permissions.includes('production.write')">
            <v-switch v-if="transaction.date > company.excisePeriodEnd || edit" :disabled="dirty"
                      v-model="edit" label="Edit" hide-details class="mt-0"/>
            <div v-else class="grey--text">Cannot edit since excise filed to period end {{company.excisePeriodEnd | formatDate}}</div>
          </template>
          <v-spacer/>
          <v-btn :plain="edit" color="primary" @click="cancel">{{edit?'Cancel':'Done'}}</v-btn>
          <v-btn v-if="edit" color="primary" :loading="saving" @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>

    <confirm-leave v-model="next"/>
  </div>

</template>

<script>
import confirmLeave from '@/mixins/confirmLeave'

export default {
  name: 'ExciseVesselInitial',
  mixins: [confirmLeave],
	props: {
    transactionId: {type:String, required:true}
	},
	data() {
		return {
      edit: false,
      valid:true,
      saving:false,
      transaction: {date:'2000-01-01 00:00:00'},
      vesselName: '',
      spirit: true,
      dirty: false
		}
  },
  computed: {
    company() {
      return this.$store.getters.company;
    }
  },
  watch: {
    transaction: {
      handler() {this.dirty = true;},
      immediate: true,
      deep: true
    }
  },
	async created() {
    const results = await this.$apiCall(`query ExciseVesselInitial($id:ID!) {
                                              exciseVesselInitial(id:$id) {
                                                id,vesselId,date,volume,litres,kg,strength,value,excise,comments,alcoholType,alcoholId,lot,siteId,imported
                                              }
                                            }`,
                                        {id:this.transactionId});
    if (results.error) {
      this.$nextTick(() => this.dirty = false);
      this.$router.back();
      return;
    }
    this.transaction = results.data.exciseVesselInitial;
    this.spirit = this.transaction.alcoholType === 'Spirit';
    delete this.transaction.alcoholType;

    const results2 = await this.$apiCall(`query ExciseVesselInitial($id:ID!) {
                                              exciseVessel(id:$id) {
                                                name
                                              }
                                            }`,
                                        {id:this.transaction.vesselId});
    if (!results2.error)
      this.vesselName = results2.data.exciseVessel.name

    this.$nextTick(() => this.dirty = false);
  },

	methods: {
    cancel() {
      this.$router.back();
    },
		async save() {
      if (this.valid) {
        this.saving = true;
        const results = await this.$apiCall(`mutation ExciseVesselInitial($input: ExciseVesselInitialInput!) {
                                                exciseVesselInitialUpdate(input:$input) {id}
                                              }`,
                                            {input:this.transaction});
        this.saving = false;
        if (!results.error) {
          this.dirty = false;
          this.$router.back();
          this.$store.commit('setError', {type:'success',message:`Updated initial inventory transaction for ${this.vesselName}`});
        }
      }
		}
	}
}
</script>